/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DatedSessionBookingStatus {
  PENDING = 'pending',
  BOOKED = 'booked',
  FAILED = 'failed',
}
